// See: RMA https://pubfs-rma.fpac.usda.gov/pub/References/insurance_control_elements/PASS/2026/2026_D00012_IceEntityType_YTD.txt
export const RmaEntityTypeCodes = {
  PublicSchools: 'A',
  BureauOfIndianAffairsAndIndianTribeTreaties: 'B',
  Corporation: 'C',
  Estates: 'D',
  NonProfitOrTaxExemptOrganizations: 'E',
  TransferOfRightToIndemnity: 'F',
  ReceiverOrLiquidator: 'G',
  StateLocalGovernment: 'H',
  Individuals: 'I',
  JointOperationsVenturesAndCoOwnerships: 'J',
  Partnership: 'P',
  TrustRevocable: 'R',
  SpousalMarried: 'S',
  TrustIrrevocable: 'T',
  IndividualOperatingAsABusiness: 'X',
  LimitedLiabilityCompany: 'Y',
} as const;

export type RmaEntityTypeCodes =
  (typeof RmaEntityTypeCodes)[keyof typeof RmaEntityTypeCodes];
